import literalValidatorsByType from '../../constants/literalValidatorsByType';
import {IEventDictionary, EventAllowlistValue} from '../../types';
import validateIsOneOf from './validateIsOneOf';

const validateEventAgainstDictionary = ({
  eventName,
  eventDictionary,
  properties = {},
}: {
  eventName: string;
  eventDictionary: IEventDictionary;
  properties?: {[x: string]: unknown};
}) => {
  const definedEvent = eventDictionary.events[eventName];

  if (!definedEvent) {
    throw new Error(`No definition found for event ${eventName} in event dictionary.`);
  }

  const trackedPropertyNames = Object.keys(properties);
  const definedPropertyNames = Object.keys(definedEvent.properties || {});

  if (!definedEvent.properties && !trackedPropertyNames.length) {
    return;
  }

  trackedPropertyNames.forEach(trackedPropertyName => {
    const isTrackedPropertyDefined = definedPropertyNames.some(definedPropertyName => {
      return definedPropertyName === trackedPropertyName;
    });

    if (!isTrackedPropertyDefined) {
      throw new Error(
        `No definition found for property ${trackedPropertyName} on event ${eventName} in event dictionary.`
      );
    }
  });

  definedPropertyNames.forEach(definedPropertyName => {
    const propertyName = definedPropertyName as EventAllowlistValue;
    const property = properties[propertyName];
    const type = definedEvent.properties![propertyName]?.type;

    if (property === undefined) {
      const definedProperty = definedEvent.properties![propertyName];

      throw new Error(
        `Invalid value "${property}" for property "${definedPropertyName}", must be of type "${definedProperty?.type}"`
      );
    }

    if (Array.isArray(type)) {
      const isValid = validateIsOneOf(type, property);

      if (!isValid) {
        throw new Error(
          `Invalid type for property ${definedPropertyName}, must be one of types: ${type.join(
            ', '
          )}`
        );
      }

      return;
    }

    const validator = literalValidatorsByType[type as string];

    if (!validator(property)) {
      throw new Error(`Invalid type for property ${definedPropertyName}, must be of type ${type}`);
    }
  });
};

export default validateEventAgainstDictionary;
